/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_YearInputs */

const cs_enum_year = /** @type {(inputs: Enum_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rok`)
};

const en_enum_year = /** @type {(inputs: Enum_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`year`)
};

/**
* | output |
* | --- |
* | "year" |
*
* @param {Enum_YearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_year = /** @type {((inputs?: Enum_YearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_YearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_year(inputs)
	return cs_enum_year(inputs)
});